import type { StyledComponent } from "@emotion/styled";
import styled from "@emotion/styled";
import type { FunctionComponent, HTMLAttributes } from "react";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";
import { SupportedContentNode } from "~/components/content/content-schema-render/enums";
import { normalizeJsxAttribute } from "~/lib/utils";

import { Heading1, Heading2, Heading3, Heading4 } from "./styles";

export type Props = {
  isStaticPage?: boolean;
} & ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({
  children,
  isStaticPage,
  reference: _content,
  schemaNode,
  ...attribs
}) => {
  const defaultRenderMap: {
    [key: string]: StyledComponent<HTMLAttributes<Element> & { type: string }>;
  } = {
    [SupportedContentNode.H1]: Heading1,
    [SupportedContentNode.H2]: isStaticPage ? Heading2 : Heading3,
    [SupportedContentNode.H3]: Heading3,
    [SupportedContentNode.H4]: Heading4,
    [SupportedContentNode.H5]: Heading4,
    [SupportedContentNode.H6]: Heading4,
  };

  if (defaultRenderMap[schemaNode.type]) {
    const Component = defaultRenderMap[schemaNode.type];
    return (
      <Component type={schemaNode.type} {...normalizeJsxAttribute(schemaNode.attribs)} {...attribs}>
        {children}
      </Component>
    );
  }

  return null;
};

Component.displayName = "Heading";
export const Heading = styled(Component)``;
